$(document).ready(function() {
    const keypointsSlider = new Flickity('.htc-blocks', {
        cellAlign: 'left',
        contain: true,
        wrapAround: false,
        pageDots: false,
        groupCells: true,
        watchCSS: true,
        draggable: true
    });
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        const hrefVal = $(this).attr('href');
        if(hrefVal === '#'){
            return;
        }
        const target = $(hrefVal);
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top - 100
            }, 0);
        }
    });

});